import { Text } from "pixi.js";
import { graphic } from "../../Graphic";

const TYPES = {
    INCREASING: 1,
    DECREASING: 2,
    INCREASING_ODD: 3,
    DECREASING_ODD: 4
};

export class RowSequence {

    static itemLabelStyle = {
        fill: 0xFFFFFF,
        align: 'center',
        fontSize: 14
    };

    constructor(row, type, offset) {
        this.row = row;
        this.direction = '+';
        this.labels = {};

        this.setType(type);
        this.setOffset(offset);
    }

    setType(type) {
        if (this.type === parseInt(type)) return;
        this.type = parseInt(type);

        this.updateLabelsValue();
        this.updateLabelsPosition();
    }

    setOffset(offset) {
        offset = parseInt(offset);
        if (this.offset === offset) return;
        this.offset = offset;

        this.updateLabelsValue();
        this.updateLabelsPosition();
    }

    updateLabelsValue() {
        graphic.rowsSeats[this.row.id] = [];
        this.row.graphicItems.forEach((graphicItem, i) => {
            const value = this.getLabelValue(i);
            graphic.rowsSeats[this.row.id].push(value);
            if (!this.labels[i]) {
                const label = new Text(value, RowSequence.itemLabelStyle);
                this.labels[i] = label;
                graphicItem.addChild(label);
            } else {
                this.labels[i].text = value;
            }
        });

        graphic.handleDuplicatedSeats();
    }

    updateLabelsPosition() {
        Object.keys(this.labels).forEach(key => {
            const label = this.labels[key];
            if (!label.parent) return;

            label.x = -(label.width / 2);
            label.y = -(label.height / 2);
        });
    }

    getLabelValue(index) {
        let value = '';
        switch (this.type) {
            case TYPES.INCREASING: {
                value = this.offset + index;
                break;
            }
            case TYPES.DECREASING: {
                value = ((this.row.graphicItems.length - 1) - index) + this.offset;
                break;
            }
            case TYPES.INCREASING_ODD: {
                let odd = -2;
                const values = this.row.graphicItems.map(() => odd += 2);
                value = values[index] + this.offset;
                break;
            }
            case TYPES.DECREASING_ODD: {
                let odd = -2;
                const values = this.row.graphicItems.map(() => odd += 2);
                value = values[(this.row.graphicItems.length - 1) - index] + this.offset;
                break;
            }
            default: {
                throw new Error(`Le type de sequence [${this.type}] est inconnu !`);
            }
        }

        return value;
    }
}